import _ from 'lodash';

export const filterCampaignsByStatus = (campaignList, status) => _.filter(campaignList, { status: status });

export const InhouseManageableCampaigns = campaignList => _.filter(campaignList, campaign => !!campaign.data.PackageInhouseManageableCities);